<div class="late-payment" *ngIf="userInfo?.pendingPayment" [ngClass]="{ suspended: userInfo?.suspendedPayment }">
	<i class="fas fa-exclamation-circle"></i>
	<span translate *ngIf="!userInfo?.suspendedPayment"
		[translateParams]="{ validUntil: userInfo?.clientSuspensionDate | date : 'shortDate' }">billing.pendingPayment</span>
	<span translate *ngIf="userInfo?.suspendedPayment">billing.suspendedPayment</span>
	<a [routerLink]="['/admin/billing']" translate class="billing-warning">billing.warningLink</a>
</div>

<header id="main-header" *ngIf="!hideMenu()">
	<div class="menu-toggle" (click)="toggelSidebar()">
		<div></div>
		<div></div>
		<div></div>
	</div>
	<div class="logo">
		<a [routerLink]="['/admin']">
			<img [src]="productInfo?.secondaryLogoUrl" [alt]="productInfo?.name" height="37px" />
		</a>
	</div>

	<div class="ml-md-auto"></div>

	<div class="header-part-right" *ngIf="isAuthenticated$ | async">
		<div ngbDropdown [placement]="'bottom-right'" class="user">
			<div id="header-user-container" class="d-flex align-items-center">
				<div class="header-icon" *ngIf="userInfo?.pictureUrl" >
					<img [src]="userInfo.pictureUrl" [alt]="userInfo?.name">
				</div>
				<i *ngIf="!userInfo?.pictureUrl" class="fal fa-user-circle header-icon"></i>
				<div class="d-flex flex-column">
					<span class="name-user">{{ userInfo?.name }}</span>
					<span *ngIf="userInfo?.tagline" class="tagline-user">{{ userInfo?.tagline }}</span>
				</div>
			</div>
		</div>
	</div>
</header>